module.exports = __webpack_public_path__ + "img/2025-11-17c_11.d335be0b.jpg";